module.exports = __webpack_public_path__ + "media/images/post_check-19382cc43c1b710f5473a1f9cf369e96.svg";